/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */

import { useFiltersContext } from '@mercadoni/sinister/dist/cjs/filters/context'
import { useProductItemEvent } from '@mercadoni/sinister/dist/cjs/monitors'

import productPath from '@/utils/productPath'
import { useRouter } from 'next/navigation'
import ProductDisplay from '../../../components/ProductDisplayv3/Async'
import ScrollToTopButton from '../../../components/ScrollToTopButton'

const ProductsBody = ({ products, category }: any) => {
  const { sendSelectProductEvent } = useProductItemEvent()
  const { fetchMoreData, pagination: { page, pages } = { page: 1, pages: 1 } } =
    useFiltersContext()

  const router = useRouter()

  const onProductClick = (product: any) => {
    sendSelectProductEvent({
      trackSource: 'deparment',
      category,
      product,
    })
    router.push(productPath(product))
  }

  return (
    <>
      <ProductDisplay
        trackSource="deparment"
        onProductClick={onProductClick}
        products={products}
        category={category}
        page={page}
        pages={pages}
        fetchMoreData={fetchMoreData}
      />
      <ScrollToTopButton />
    </>
  )
}

export default ProductsBody
